import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
} from '../exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import {
  coerceAtMost322komnqp70ag as coerceAtMost,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
} from '../ranges/_Ranges.mjs';
import {
  substringiqarkczpya5m as substring,
  substring3saq8ornu0luv as substring_0,
} from './stringJs.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charSequenceSubSequence1iwpdba8s3jc7 as charSequenceSubSequence,
} from '../js/charSequenceJs.mjs';
import { get_lastIndexld83bqhfgcdd as get_lastIndex } from './Strings.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from './StringBuilderJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { checkWindowSizeStepcg5bise2nnst as checkWindowSizeStep } from '../collections/SlidingWindow.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../collections/ArrayListJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function take(_this__u8e3s4, n) {
  // Inline function 'kotlin.require' call
  if (!(n >= 0)) {
    var message = 'Requested character count ' + n + ' is less than zero.';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
  }
  return substring(_this__u8e3s4, 0, coerceAtMost(n, _this__u8e3s4.length));
}
function drop(_this__u8e3s4, n) {
  // Inline function 'kotlin.require' call
  if (!(n >= 0)) {
    var message = 'Requested character count ' + n + ' is less than zero.';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
  }
  return substring_0(_this__u8e3s4, coerceAtMost(n, _this__u8e3s4.length));
}
function last(_this__u8e3s4) {
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(_this__u8e3s4) === 0)
    throw NoSuchElementException().new_kotlin_NoSuchElementException_eborbh_k$('Char sequence is empty.');
  return charSequenceGet(_this__u8e3s4, get_lastIndex(_this__u8e3s4));
}
function single(_this__u8e3s4) {
  var tmp;
  switch (charSequenceLength(_this__u8e3s4)) {
    case 0:
      throw NoSuchElementException().new_kotlin_NoSuchElementException_eborbh_k$('Char sequence is empty.');
    case 1:
      tmp = charSequenceGet(_this__u8e3s4, 0);
      break;
    default:
      throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Char sequence has more than one element.');
  }
  return tmp;
}
function chunked(_this__u8e3s4, size, transform) {
  return windowed(_this__u8e3s4, size, size, true, transform);
}
function reversed(_this__u8e3s4) {
  return StringBuilder().new_kotlin_text_StringBuilder_42giwq_k$(_this__u8e3s4).reverse_i6tiw2_k$();
}
function takeLast(_this__u8e3s4, n) {
  // Inline function 'kotlin.require' call
  if (!(n >= 0)) {
    var message = 'Requested character count ' + n + ' is less than zero.';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
  }
  var length = _this__u8e3s4.length;
  return substring_0(_this__u8e3s4, length - coerceAtMost(n, length) | 0);
}
function windowed(_this__u8e3s4, size, step, partialWindows, transform) {
  step = step === VOID ? 1 : step;
  partialWindows = partialWindows === VOID ? false : partialWindows;
  checkWindowSizeStep(size, step);
  var thisSize = charSequenceLength(_this__u8e3s4);
  var resultCapacity = (thisSize / step | 0) + ((thisSize % step | 0) === 0 ? 0 : 1) | 0;
  var result = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(resultCapacity);
  var index = 0;
  $l$loop: while (0 <= index ? index < thisSize : false) {
    var end = index + size | 0;
    var tmp;
    if (end < 0 || end > thisSize) {
      var tmp_0;
      if (partialWindows) {
        tmp_0 = thisSize;
      } else {
        break $l$loop;
      }
      tmp = tmp_0;
    } else {
      tmp = end;
    }
    var coercedEnd = tmp;
    result.add_utx5q5_k$(transform(charSequenceSubSequence(_this__u8e3s4, index, coercedEnd)));
    index = index + step | 0;
  }
  return result;
}
function dropLast(_this__u8e3s4, n) {
  // Inline function 'kotlin.require' call
  if (!(n >= 0)) {
    var message = 'Requested character count ' + n + ' is less than zero.';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
  }
  return take(_this__u8e3s4, coerceAtLeast(_this__u8e3s4.length - n | 0, 0));
}
function firstOrNull(_this__u8e3s4) {
  var tmp;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(_this__u8e3s4) === 0) {
    tmp = null;
  } else {
    tmp = charSequenceGet(_this__u8e3s4, 0);
  }
  return tmp;
}
//region block: exports
export {
  chunked as chunked3v1tthtda414w,
  dropLast as dropLastlqc2oyv04br0,
  drop as drop336950s126lmj,
  firstOrNull as firstOrNulltrxqttxfxqju,
  last as last2n4gf5az1lkn4,
  reversed as reversed3umwqsxpi431x,
  single as single29ec4rh52687r,
  takeLast as takeLast2r8kr8e6g6hi7,
  take as take9j4462mea726,
};
//endregion

//# sourceMappingURL=_Strings.mjs.map
